webpackJsonp([1],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  "data-v-58f4f397",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(191),
  /* scopeId */
  "data-v-3a35dc6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(190),
  /* scopeId */
  "data-v-39717718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(189),
  /* scopeId */
  "data-v-0e0279a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.contents), function(content) {
    return _c('div', [_c('img', {
      attrs: {
        "src": content.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    }), _vm._v(" "), (_vm.input.isActive) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputVal),
        expression: "inputVal"
      }],
      attrs: {
        "type": "text",
        "name": "input",
        "placeholder": _vm.input.placeholder
      },
      domProps: {
        "value": (_vm.inputVal)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.onSubmit.apply(null, arguments)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.inputVal = $event.target.value
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.secondInput.isActive) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.secondInputVal),
        expression: "secondInputVal"
      }],
      attrs: {
        "type": "text",
        "name": "input",
        "placeholder": _vm.secondInput.placeholder
      },
      domProps: {
        "value": (_vm.secondInputVal)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.onSubmit.apply(null, arguments)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.secondInputVal = $event.target.value
        }
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "button-caption"
    }, [(option.type != 'done' && option.isOption && !_vm.input.isActive && !option.isHttpRequest) ? _c('router-link', {
      class: {
        'yes': option.type == 'yes',
        'no': option.type == 'no',
        'continue': option.type == 'continue',
      },
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: option.id
          }
        }
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.type != 'done' && !option.isOption && !_vm.input.isActive && !option.isHttpRequest) ? _c('router-link', {
      class: {
        'yes': option.type == 'yes',
        'no': option.type == 'no',
        'continue': option.type == 'continue',
      },
      attrs: {
        "to": {
          name: 'Question',
          params: {
            id: option.id
          }
        }
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.input.isActive) ? _c('a', {
      class: {
        'yes': option.type == 'yes',
        'no': option.type == 'no',
        'continue': option.type == 'continue',
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.isHttpRequest) ? _c('a', {
      class: {
        'yes': option.type == 'yes',
        'no': option.type == 'no',
        'continue': option.type == 'continue',
      },
      on: {
        "click": option.onClick
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.type === 'done') ? _c('router-link', {
      staticClass: "continue",
      attrs: {
        "to": {
          name: 'Success'
        }
      }
    }, [_c('span', [_vm._v("BİTİR")])]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', [_vm._l((_vm.steps), function(step, index) {
    return _c('li', [(!step.isOption) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": step.url
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n      ")]) : _vm._e(), _vm._v(" "), (step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.information) ? _c('li', {
    staticClass: "information"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.information)
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', _vm._l((_vm.steps), function(step, index) {
    return _c('li', [(!step.isOption) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": step.url
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n      ")]) : _vm._e(), _vm._v(" "), (step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.path !== '/chat') ? _c('div', {
    staticClass: "header"
  }, [(_vm.$route.path === '/') ? _c('div', {
    staticStyle: {
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.$route.path === '/' || _vm.$route.path === '/contact') || !(_vm.$route.query.gim == null)) ? _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._m(0), _vm._v("\n      Geri\n    ")]) : _vm._e(), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/chat') ? _c('div', {
    staticClass: "header chat-header"
  }, [(_vm.$route.path === '/') ? _c('div', {
    staticStyle: {
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.$route.path !== '/' && !(_vm.$route.query.gim == null))) ? _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._m(1), _vm._v("\n      Geri\n    ")]) : _vm._e(), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("\npowered by "), _c('a', {
    attrs: {
      "href": "https://connexease.com",
      "target": "_blank"
    }
  }, [_vm._v("Connexase")])])
}]}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat"
  }, [_c('iframe', {
    attrs: {
      "src": "https://livechat.connexease.com/embed/5d432f58-c1e6-4b09-b5ce-481421020719"
    }
  })])
}]}

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(182)

module.exports = {
  company: 'Millenicom',
  build: {
    env: __webpack_require__(42),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(79),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GetStarted__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GetStarted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_GetStarted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Question__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Option__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Chat__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Chat__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'GetStarted',
    component: __WEBPACK_IMPORTED_MODULE_2__components_GetStarted___default.a
  }, {
    path: '/chat',
    name: 'Chat',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Chat___default.a
  }, {
    path: '/question/:id',
    name: 'Question',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Question___default.a,
    props: true
  }, {
    path: '/option/:id',
    name: 'Option',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Option___default.a
  }]
}));

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(196)
var prodEnv = __webpack_require__(42)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: 'UA-10920282-25',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        company: __WEBPACK_IMPORTED_MODULE_5__config___default.a.company,
        location: window.location.href
      };
    }
  }
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: {
    goBack: function goBack() {
      if (window.location.pathname === '/option/1') {
        window.location.href = window.location.origin;
      } else if (window.location.href !== 'https://milleni.connexease.com') {
        window.location.href = window.location.origin + '/option/1';
      }

      return false;
    }
  }
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chat',
  methods: {}
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GetStarted',
  data: function data() {
    return {
      steps: [{
        title: 'Millenicom Müşterisiyim',
        id: 1,
        isOption: true
      }, {
        title: 'Millenicom Müşterisi Değilim',
        id: 2,
        isOption: false,
        url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisi Değilim'
      }]
    };
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Option',
  data: function data() {
    return {
      information: false,
      steps: []
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: function $route() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      if (this.$route.params.id == 1) {
        this.steps = [{
          title: 'Teknik Destek Almak İstiyorum ',
          id: 3,
          isOption: true
        }, {
          title: 'Fatura İşlemleri',
          id: 4,
          isOption: true
        }, {
          title: 'Nakil İşlemleri',
          id: 5,
          isOption: true
        }, {
          title: 'Aktivasyonum Hakkında Bilgi Almak İstiyorum',
          id: 6,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Aktivasyonum Hakkında Bilgi Almak İstiyorum'
        }, {
          title: 'Tarife İşlemleri',
          id: 7,
          isOption: true
        }, {
          title: 'Modem satın almak istiyorum',
          id: 8,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Modem satın almak istiyorum'
        }, {
          title: 'Diğer',
          id: 9,
          isOption: true
        }];
      }

      if (this.$route.params.id == 4) {
        this.steps = [{
          title: 'Ödenmemiş Faturalar Hakkında Bilgi Almak İstiyorum',
          id: 10,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Ödenmemiş Faturalar Hakkında Bilgi Almak İstiyorum'
        }, {
          title: 'Ödeme Kanalları Hakkında Bilgi Almak istiyorum',
          id: 11,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Ödeme Kanalları Hakkında Bilgi Almak istiyorum'
        }, {
          title: 'Cayma Bedelimi Öğrenmek İstiyorum',
          id: 12,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Cayma Bedelimi Öğrenmek İstiyorum'
        }, {
          title: 'Fatura Kesim Tarihini Öğrenmek İstiyorum',
          id: 13,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Fatura Kesim Tarihini Öğrenmek İstiyorum'
        }, {
          title: 'Fatura Şikayeti',
          id: 14,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Fatura Şikayeti'
        }, {
          title: 'Diğer',
          id: 15,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Fatura İşlemleri / Diğer'
        }];
      }

      if (this.$route.params.id == 3) {
        this.steps = [{
          title: 'Hız Problemi',
          id: 16,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Hız Problemi'
        }, {
          title: 'Sık Kopma Problemi',
          id: 17,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Sık Kopma Problemi'
        }, {
          title: 'İnternete Giremiyorum',
          id: 18,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / İnternete Giremiyorum'
        }, {
          title: 'Modem Kurulumu',
          id: 19,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Modem Kurulumu'
        }, {
          title: 'Diğer',
          id: 20,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Teknik Destek Almak İstiyorum / Diğer'
        }];
      }
      if (this.$route.params.id == 5) {
        this.steps = [{
          title: 'Nakil Başlatmak İstiyorum',
          id: 21,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Nakil İşlemleri / Nakil Başlatmak İstiyorum'
        }, {
          title: 'Nakil Başvurumun Durumunu Öğrenmek İstiyorum',
          id: 22,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Nakil İşlemleri / Nakil Başvurumun Durumunu Öğrenmek İstiyorum'
        }];
      }
      if (this.$route.params.id == 7) {
        this.steps = [{
          title: 'Tarife / Taahhüt Bilgilerimi Öğrenmek İstiyorum',
          id: 23,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Tarife İşlemleri / Tarife / Taahhüt Bilgilerimi Öğrenmek İstiyorum'
        }, {
          title: 'Tarifemi değiştirmek istiyorum',
          id: 24,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Tarife İşlemleri / Tarifemi değiştirmek istiyorum'
        }];
      }
      if (this.$route.params.id == 9) {
        this.steps = [{
          title: 'Müşteri Numaramı Öğrenmek İstiyorum',
          id: 25,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Müşteri Numaramı Öğrenmek İstiyorum'
        }, {
          title: 'Bilgilerimi Güncellemek İstiyorum',
          id: 26,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Bilgilerimi Güncellemek İstiyorum'
        }, {
          title: 'Online İşlemlere Giriş Yapmak İstiyorum',
          id: 27,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Online İşlemlere Giriş Yapmak İstiyorum'
        }, {
          title: 'Diğer',
          id: 28,
          isOption: false,
          url: 'https://api.whatsapp.com/send?phone=905393330333&text=Millenicom Müşterisiyim / Diğer / Diğer'
        }];
      }
    }
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Question',
  data: function data() {
    return {
      contents: [],
      options: [],
      inputVal: '',
      secondInputVal: '',
      input: {
        isActive: false,
        placeholder: null,
        value: null
      },
      secondInput: {
        isActive: false,
        placeholder: null,
        value: null
      },
      onSubmit: null
    };
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[80]);


// WEBPACK FOOTER //
// static/js/app.4955393e5488bdebfea4.js